import React from "react";
import Buttons from "2g-buttons";
import { Icons } from "2g-icons";

export default function (handleClick) {
  return {
    id: "acceptAction",
    isAction: true,
    onClick: handleClick,
    path: "",
    renderer: () => (
      <Buttons.Success inverse rounded>
        <Icons.Check />
      </Buttons.Success>
    )
  };
}
